import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Date question component.
 * Displays and configures a date-picker question using the native date input.
 * Uses Angular signals inherited from BaseQuestionComponent.
 */
@Component({
  selector: 'app-date-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './date-question.component.html',
  styleUrl: './date-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateQuestionComponent extends BaseQuestionComponent {
  dateValue: string = '';

  onLabelChange(value: string): void {
    this.updateLabel(value);
  }

  onHelperTextChange(value: string): void {
    this.updateHelperText(value);
  }

  onAdditionalInfoChange(value: string): void {
    this.updateAdditionalInfo(value);
  }

  onDateChange(value: string): void {
    this.dateValue = value;
  }

  onRequiredToggle(): void {
    this.updateRequired(!this.question().isRequired);
  }
}
